import React,{useState} from "react";
import { Link } from "react-router-dom";

import Navbar from "../components/navbar";

import ModalVideo from 'react-modal-video';
import "../../node_modules/react-modal-video/css/modal-video.css"

import Youtubeembed from "../components/youtubeembed";

import Footer from "../components/footer";
import curvedBanner from "../assect/images/bg/dl_curvedimg_troy.png";

const embedId = "jjJ8Sd9RWPQ";

export default function DiscoverTroy(){
    const [isOpen, setOpen] = useState(false)
    return(
        <div style={{backgroundColor: "#f0eadd"}}>
            <Navbar navClass="defaultscroll sticky" menuClass = "navigation-menu nav-right"/>
            <div className="top-half top-half d-table w-100" style={{paddingTop:"74px"}}>
                <section className="bg-half-116" style={{backgroundImage:`url(${curvedBanner})`}}>
                </section>
            </div>            

            <section className="section-50 pb-0 mb-60">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <p className="mb-5" style={{textAlign: "center", fontSize: "36pt", color:"#093b38", fontFamily:"Bacasime Antique"}}>Discover Troy</p>
                            <div className="p-4">
                                <Youtubeembed embedId={embedId} />
                            </div>
                        </div>
                    </div>
                </div>

            </section>
            <Footer/>
        </div>        
        
    )
}
